<div class="simple-card page-item">
  <a href="{{ page.url }}">
    <h3 class="title text-primary">
      {{ page.title }}
    </h3>
  </a>

  <p class="description">
    {{ page.description }}
  </p>

  <a href="{{ page.url }}" class="m-t-20">{{ 'contentPages.pageItem.readMore' | cxTranslate }}</a>
</div>